export default function(h, row, index) {
    let _s1 = '';
    if (is(row.user)) {
        _s1 =  row.user.surname + ' ' +  row.user.name_ + ' ' + row.user.patro + ' (' + row.user.login + ')';
    }

    return <span class="vouchers_table__user">{_s1}</span>

}
